import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserService } from '../../shared/service/user-service';
import { RequirementService } from 'src/app/shared/service/requirement-service';
import { Routes } from '@angular/router';
import { ZipFileDownloadDialog } from 'src/app/zip-file-download/zip-file-download-dialog.component';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs';
import { JobSourcingDialog } from 'src/app/shared/dialogs/job-sourcing/job-sourcing.component';
import { ThemeService } from 'src/app/theme';
import { TabRestrictDialog } from 'src/app/tab-restrict-dialog/tab-restrict-dialog.component';
import { LocalStorageUtil } from 'src/app/shared/utils/local-storage/local-storage-util';
import { SnackBarUtil } from 'src/app/shared/utils/snackbar/snackbar-util';
import { SnackbarConstants } from 'src/app/constants/snackbar-constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public innerWidth: any;
  navtab = 0;
  loggedInUsername: string;
  loggedInOrgid: number;
  loggedInCandidateId: any;
  loggedInUserrole: Array<string>;
  url = '';
  language = 'English';
  isChecked = false;
  themeType = 'default';
  orgName = environment.orgname;
  selectedLanguage: string = 'English';
  urlChange = false;
  currentDisplayLanguage: string = 'en';
  isProfileEdit: boolean = false;
  isLanguageActive: boolean = true;
  // currentLanguage: string = 'en'

  constructor(private requirementservice: RequirementService,private snackBarUtil: SnackBarUtil, private route: ActivatedRoute, private router: Router, public dialog: MatDialog, private snackBar: MatSnackBar, private userService: UserService, private themeService: ThemeService, private localStorageUtil: LocalStorageUtil) {
    if (this.localStorageUtil.isAccessTokenPresentAndValid()) {
      let accesstoken = this.localStorageUtil.getAccessToken();
      this.loggedInUsername = accesstoken?.loggedInUsername;
    }
    // this.language = sessionStorage.getItem('currentlanguage');
    this.currentDisplayLanguage = sessionStorage.getItem('currentlanguage') || 'en';
    this.url = router.url;
    this.userService.logoutInvalidCurrentUserObservable$.subscribe(data => {
      if (data) {
        this.logoutInvalidUser();
      }
    });

    this.userService.clearDataastring$.subscribe(e => {
      if (e === 'clear') {
        this.clearUserData();
        this.userService.setClearLocalStorage('');

      }
    });
    this.userService.isProfileEditActive$.subscribe(isactive => {
      if (isactive !== '' && isactive != undefined && isactive != null) {
        this.isProfileEdit = isactive;
      }
      else {
        this.isProfileEdit = false;
      }
    });
    this.userService.isLanguageActive$.subscribe(isactive => {
      if (isactive !== '' && isactive != undefined && isactive != null) {
        this.isLanguageActive = isactive;
      }
    });

    if (this.url.includes('/careers') && !this.url.includes('/careers/')) {
      this.navtab = 0;
    } else {
      this.navtab = 1;
    }
    this.userService.changelanguage();
    this.userService.themesDatastring$.subscribe(e => {
      if (e != '' && e != ' ' && e != undefined && e != null && e != 'null') {
        this.themeService.setTheme(e);
      }
    });
  }

  ngOnInit(): void {
    this.removeTranslateDialog();
    //the variable innerWidth is assigned with the window's innerWidth
    if (window.innerWidth > 767) {
      this.innerWidth = true
    }
    else {
      this.innerWidth = false
    }
    this.routeChecker();
  }

  routeChecker() {
    // this if for oninit call then check URL - reload
    if (this.url.includes('/careers/my-profile')) {
      this.urlChange = true;
    } else {
      this.urlChange = false;
    }
    // this is for dynamically change URL
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Handle URL change here
        if (event.url.includes('/careers/my-profile')) {
          this.urlChange = true;
        } else {
          this.urlChange = false;
        }
        // You can perform actions based on the new URL, such as fetching data or updating the UI
      });
  }

  //On window resize this method is called
  //the new innerWidth is stored to variable innerWidth
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.routeChecker();
    if (window.innerWidth > 767) {
      this.innerWidth = true
    }
    else {
      this.innerWidth = false
    }
  }

  //navigates to login page
  login() {
    this.navtab = 0;
    this.router.navigate(['careers/auth/'], { queryParams: { url: this.router.url }, replaceUrl: true });
  }

  submitProfile() {
    if (this.localStorageUtil.isAccessTokenPresentAndValid()) {
      this.myProfile();
    } else {
      this.login();
      this.localStorageUtil.setReferPage('profileNav')
    }
  }

  // Written by Sharmi for Themes
  setTheme() {
    if (this.themeType === 'default') {
      this.themeType = 'icrisat';
    } else {
      this.themeType = 'default';
    }
    this.userService.setDynamicTheme(this.themeType);
  }

  arabic() {
    // localStorage.setItem('language', 'Arabic');
    // window.location.href = "https://careers-crescoworks-net.translate.goog/careers?_x_tr_sl=en&_x_tr_tl=ar&_x_tr_hl=en&_x_tr_pto=wapp&_x_tr_hist=true"
    // this.selectedLanguage = "Arabic";
  }

  french() {
    // localStorage.setItem('language', 'French');
    window.location.href = "https://naquacareers-crescoworks-com.translate.goog/careers?_x_tr_sl=en&_x_tr_tl=fr&_x_tr_hl=en&_x_tr_pto=wapp&_x_tr_hist=true"
    // this.selectedLanguage = "French";

  }

  German() {
    // localStorage.setItem('language', 'German');
    window.location.href = "https://naquacareers-crescoworks-com.translate.goog/careers?_x_tr_sl=en&_x_tr_tl=de&_x_tr_hl=en&_x_tr_pto=wapp&_x_tr_hist=true"
    // this.selectedLanguage = "German";

  }

  Spanish() {
    // localStorage.setItem('language', 'Spanish');
    window.location.href = "https://naquacareers-crescoworks-com.translate.goog/careers?_x_tr_sl=en&_x_tr_tl=es&_x_tr_hl=en&_x_tr_pto=wapp&_x_tr_hist=true"
    // this.selectedLanguage = "Spanish";

  }

  Italian() {
    // localStorage.setItem('language', 'Italian');
    window.location.href = "https://naquacareers-crescoworks-com.translate.goog/careers?_x_tr_sl=en&_x_tr_tl=it&_x_tr_hl=en&_x_tr_pto=wapp&_x_tr_hist=true"
    // this.selectedLanguage = "Italian";

  }

  originalWebsite() {
    const url = environment.SERVER_URL
    window.open(url, "_self");
  }

  onBoardComponent() {
    this.router.navigate(['/careers/onboard']);
  }
  //navigates to applied jobs page
  myJobs() {
    this.navtab = 3;
    this.router.navigate(['careers/my-jobs']);
  }

  //navigate to open positions page
  openPositions() {
    this.navtab = 0;
    this.router.navigate(['']);
  }

  //logout from the account
  logout() {
    if (this.isProfileEdit === false) {
      if (this.localStorageUtil.isAccessTokenPresentAndValid()) {
        let accesstoken = this.localStorageUtil.getAccessToken();
        this.userService.logout(accesstoken.jti).subscribe(response => {
          this.clearUserData();
          this.openPositions();
        }, error => {
          this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
          this.clearUserData();
          this.openPositions();
        })
      }
      else {
        this.clearUserData();
        this.openPositions();
      }
    }
    else {
      let dialogRef;
      dialogRef = this.dialog.open(TabRestrictDialog, {
        data: { disableClose: true, },
      });
      dialogRef.afterClosed().subscribe(data => {
        if (data === 'discard') {
          this.userService.isCandProfileEditCancel(true);
          this.userService.setPreventData(false);
          this.userService.isCandProfileEditActive(false);//For Hide Language Change while Canidate Edit
          this.logout();
        }
      })
    }
  }

  // logs out if the token it invalid
  logoutInvalidUser() {
    if (this.localStorageUtil.isAccessTokenPresentAndValid()) {
      let accesstoken = this.localStorageUtil.getAccessToken();
      this.userService.discardInvalidTokens(accesstoken.jti).subscribe(response => {
        this.clearUserData();
        this.openPositions();
      }, error => {
        this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
        this.clearUserData();
        this.openPositions();
      })
    }
    else {
      this.clearUserData();
      this.openPositions();
    }
  }
  // clears the token related data
  clearUserData() {
    this.localStorageUtil.clearLocalStorageExceptExclusionKey();
    this.loggedInUsername = null;
    this.loggedInOrgid = null;
    this.loggedInCandidateId = null;
    this.loggedInUserrole = null;
  }

  // navigates to candidate my profile
  myProfile() {
    this.navtab = 3;
    this.router.navigate(['careers/my-profile']);
  }

  // navigates to change password page
  changePassword() {
    this.navtab = 3;
    this.router.navigate(['careers/change-password']);
  }

  expandDownloadDialog() {
    let dialogRef;
    dialogRef = this.dialog.open(ZipFileDownloadDialog, {
      width: '635px',
    });
  }

  expandJobsourcing() {
    let dialogRef = this.dialog.open(JobSourcingDialog, {
      minWidth: "50%",
      width: '74%',
    });
    dialogRef.afterClosed().subscribe(data => {
    })
  }

  //it was an remove translate dialog when shown by google
  removeTranslateDialog() {
    setInterval(() => {
      const dialog = document.querySelector('md-dialog[type="alert"]');
      if (dialog) {
        dialog.remove(); // Removes the dialog from the DOM
      }
    }, 1000); // Check every second (adjust as necessary)
  }
}